import React, {useState, useEffect, useContext } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonLabel, IonText, IonInput, IonFooter } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';
import { ShowScopePicsModal } from './Modal_ShowScopePics';
import { ViewScopeEstimatesModal } from './Modal_ViewScopeEstimates';
import { ViewScopeExpensesModal } from './Modal_ViewScopeExpenses';



export function ScopeDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewConsultationDetailData, setViewConsultationDetailData] = useState([]);
    let [viewScopeList, setViewScopeList] = useState([]);


    let [consultationID, setConsultationID] = useState(null);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);


    let [createScopeName, setCreateScopeName] = useState(null);
    let [createScopeDescription, setCreateScopeDescription] = useState(null);
    let [scopeEstimatesModal, setScopeEstimatesModal] = useState(false);
    let [scopeExpensesModal, setScopeExpensesModal] = useState(false);
    let [newScopeEstimatedPrice, setNewScopeEstimatedPrice] = useState(null);

    let [scopePicsModal, setScopePicsModal] = useState(false);
    let [scopePicsModal_finished, setScopePicsModal_finished] = useState(false);


   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

        //alert('In Occupied Detailed Data');
        //alert(props.openModal);

        if(props.openModal == true)
        {


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_scope_details',
                    user: acctID,
                    xConsultationID: props.data.consultationID,
                    xScopeNumber: props.data.scopeNumber,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');


                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setConsultationID(cols[0]);

                    setViewScopeList((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            consultationID: cols[0],
                            scopeNumber: cols[1],
                            scopeName: cols[3],
                            scopeDescription: cols[4],
                            scopeEstimateAmount: cols[5],
                            scopeExpenses: cols[6],
                            dateLogged: new Date(cols[7]).toISOString().substr(0, 10),
                            assigned: parseFloat(cols[8]).toFixed(2),
                            lastModified: cols[9],
                            status: cols[10],
                            scopePic1: cols[11],
                            scopePic2: cols[12],
                            scopePic3: cols[13],
                            scopePic4: cols[14],
                            scopePic1_finished: cols[15],
                            scopePic2_finished: cols[16],
                            scopePic3_finished: cols[17],
                            scopePic4_finished: cols[18],


                        })
                    });
                } 
            })
        }
    }, [props.openModal]);

    function saveScope()
    {
        alert("In Save Scope")
    }


    function closeModalHandler() {

        setViewConsultationDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader className='grid_checkInHeader'>
            <IonGrid class='gridModalTopInfo'>
                    <IonRow>
                        <IonCol> Consultation ID</IonCol>
                        <IonCol> {props.data.consultationID} </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonButton>Add Scope</IonButton>
                        </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent >

        <div>
                {viewScopeList.map((detailData) =>   {
                    return (

                    <IonGrid>

                    <IonRow> 
                        <IonCol>
                            <IonLabel>Scope Name: </IonLabel>
                        </IonCol>
                        <IonCol>
                            {row_2 == true && <IonInput placeholder='Enter Product Description'  onIonChange={(e) => setCreateScopeName(e.detail.value)}></IonInput>}
                            {row_2 == false && <IonText>{createScopeName} </IonText>}
                        </IonCol>
                        {row_2 == false && <IonCol>
                            <IonButton onClick={() => setRow_2(true)}>Update</IonButton>
                        </IonCol>}
                        {row_2 == true && <IonCol>
                            <IonButton onClick={() => setRow_2(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonLabel>Scope Description: </IonLabel>
                        </IonCol>
                        <IonCol>
                            {row_3 == true && <IonInput placeholder='Enter Product Description' onIonChange={(e) => setCreateScopeDescription(e.detail.value)}></IonInput>}
                            {row_3 == false && <IonText>{createScopeDescription}</IonText>}
                        </IonCol>
                        {row_3 == false && <IonCol>
                            <IonButton onClick={() => setRow_3(true)}>Update</IonButton>
                        </IonCol>}
                        {row_3 == true && <IonCol>
                            <IonButton onClick={() => setRow_3(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow >
                        <IonCol >Scope Estimates</IonCol>
                        <IonCol >{detailData.scopeEstimateAmount}</IonCol>
                        <IonCol >
                            <IonButton onClick={() => setScopeEstimatesModal(true)}> View </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow >
                        <IonCol >Scope Expenses</IonCol>
                        <IonCol >{detailData.scopeExpenses}</IonCol>
                        <IonCol >
                            <IonButton onClick={() => setScopeExpensesModal(true)}> View </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow >
                        <IonCol >Scope Images Initial</IonCol>
                        <IonCol >{detailData.assigned}</IonCol>
                        <IonCol >
                            <ShowScopePicsModal openModal={ scopePicsModal } closeModal={() => setScopePicsModal(false)} data={{
                            scopePic1: detailData.scopePic1, 
                            scopePic2: detailData.scopePic2, 
                            scopePic3: detailData.scopePic3, 
                            scopePic4: detailData.scopePic4, 
                            scopeNumber: detailData.scopeNumber, 
                            scopeEstimateAmount: detailData.scopeEstimateAmount,
                            scopeExpenses: detailData.scopeExpenses,
                            consultationID: props.data.consultationID
                            }}></ShowScopePicsModal>
                            <IonButton onClick={() => setScopePicsModal(true)}> Add/View </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow >
                        <IonCol >Scope Images Finished</IonCol>
                        <IonCol >{detailData.assigned}</IonCol>
                        <IonCol >
                            <ShowScopePicsModal openModal={ scopePicsModal_finished } closeModal={() => setScopePicsModal_finished(false)} data={{
                            scopePic1: detailData.scopePic1_finished, 
                            scopePic2: detailData.scopePic2_finished, 
                            scopePic3: detailData.scopePic3_finished, 
                            scopePic4: detailData.scopePic4_finished, 
                            scopeNumber: detailData.scopeNumber, 
                            scopeEstimateAmount: detailData.scopeEstimateAmount,
                            scopeExpenses: detailData.scopeExpenses,
                            consultationID: props.data.consultationID
                            }}></ShowScopePicsModal>
                            <IonButton onClick={() => setScopePicsModal_finished(true)}> Add/View </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonLabel>Total Estimated Price: </IonLabel>
                        </IonCol>
                        <IonCol>
                            {row_4 == true && <IonInput placeholder='Enter Product Phone Number' onIonChange={(e) => setNewScopeEstimatedPrice(e.detail.value)}></IonInput>}
                            {row_4 == false && <IonText>{detailData.scopeEstimateAmount}</IonText>}
                        </IonCol>
                        {row_4 == false && <IonCol>
                            <IonButton onClick={() => setRow_4(true)}>Update</IonButton>
                        </IonCol>}
                        {row_4 == true && <IonCol>
                            <IonButton onClick={() => setRow_4(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    </IonGrid>

                 )} 
            )}


        </div>
        </IonContent>


        <IonFooter className='modal_footer_button_center'>
            <IonGrid>
                <IonRow>
                    <IonCol>
                        <IonButton onClick={() => saveScope()}> Save </IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton onClick={closeModalHandler}> Close </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonFooter>

    </IonModal>) : null}

    {scopeEstimatesModal == true && <ViewScopeEstimatesModal openModal={ scopeEstimatesModal } closeModal={() => setScopeEstimatesModal(false)} data={{
                                            consultationID: props.data.consultationID, 
                                            scopeLineNumber: props.data.scopeLineNumber, 
                                            }}></ViewScopeEstimatesModal>}

    {scopeExpensesModal == true &&  <ViewScopeExpensesModal openModal={ scopeExpensesModal } closeModal={() => setScopeExpensesModal(false)} data={{
                                            consultationID: props.data.consultationID, 
                                            scopeLineNumber: props.data.scopeLineNumber, 
                                            }}></ViewScopeExpensesModal>}
    </React.Fragment>
    )
}